import { Fragment, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { useEffect } from 'react';
import { noop } from 'shell/utils/noop';
import FormQualification, { QualificationForm } from 'system/components/qualifications/form';
import ListOperator from 'system/components/qualifications/operators';
import { Qualification } from 'shell/models/qualification';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonQualificationCrumbs } from '../constants';

const QualificationDetailPage = (): React.ReactElement => {
  const params = useParams();
  const {
    data,
    loading,
    error,
    get: getQualification,
  } = useHttpFetch<HttpResponse<Qualification>>(
    `${__MANAGEMENT_API_URL__}/qualifiche/${params.id}`,
    {
      data: {},
    }
  );

  const qualificationInitialValues: QualificationForm = useMemo(() => {
    const qualification = data?.payload;
    if (!qualification || !!error) {
      return {
        code: '',
        name: '',
      };
    }
    return {
      code: qualification.key?.codiceQualifica,
      name: qualification.descrizione,
      lastUpdate: qualification.note,
    };
  }, [data]);

  const navigate = useNavigate();

  useEffect(() => {
    getQualification();
  }, [params.id]);

  const onDetailPress = (idOperatore: string) => {
    navigate(`/sistema/qualifiche/dettaglio/${params.id}/operatori/dettaglio/${idOperatore}`);
    return;
  };

  const onEditPress = (idOperatore: string) => {
    navigate(`/sistema/qualifiche/dettaglio/${params.id}/operatori/modifica/${idOperatore}`);
    return;
  };

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonQualificationCrumbs, { name: 'Dettaglio Qualifica' }]} />
      {loading && !data ? null : (
        <FormQualification
          title={'Dettaglio Qualifica'}
          onOk={noop}
          onCancel={() => {
            navigate('/sistema/qualifiche');
          }}
          disabled
          initialValues={qualificationInitialValues}
        >
          <ListOperator
            onDetailPress={onDetailPress}
            onEditPress={onEditPress}
            qualificationId={qualificationInitialValues.code}
          />
        </FormQualification>
      )}
    </Fragment>
  );
};

QualificationDetailPage.displayName = 'Qualification Detail page component';

export default QualificationDetailPage;
